import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';

type PillVariant = 'outline' | 'ghost' | 'primary';

const PILL_VARIANTS: Record<PillVariant, string> = {
  outline: 'border-gray-500 bg-white text-text-heading',
  ghost: 'text-muted-foreground',
  primary: 'border border-text-quote bg-ink text-white hover:bg-ink/90',
};

/** 28px rounded pill from the design, in its outline, ghost and dark primary forms. */
export const PillButton = ({
  dashed,
  variant = 'outline',
  className,
  ...props
}: Omit<ComponentProps<typeof Button>, 'variant'> & { dashed?: boolean; variant?: PillVariant }) => (
  <Button
    variant={variant === 'primary' ? 'default' : variant}
    size='sm'
    className={cn(
      'h-7 rounded-full px-3 text-[13px] leading-4.5 font-normal',
      PILL_VARIANTS[variant],
      dashed && 'border-dashed hover:bg-gray-50',
      className
    )}
    {...props}
  />
);
